module.exports = __webpack_public_path__ + "img/speak_no_evil_monkey.3b7cea02.gif";